var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-cell-group",
    { staticClass: "UPhone" },
    [
      _c("van-field", {
        staticClass: "inputBar",
        attrs: {
          label: "手机号",
          required: "",
          placeholder: "请输入手机号",
          "error-message": _vm.phoneValidateText,
          blur: _vm.PhoneValidate
        },
        model: {
          value: _vm.phone,
          callback: function($$v) {
            _vm.phone = $$v
          },
          expression: "phone"
        }
      }),
      _vm._v(" "),
      _c(
        "van-col",
        {
          staticClass: "barBtn",
          attrs: { span: "24", type: "flex", justify: "space-between" }
        },
        [
          _c(
            "van-button",
            {
              staticClass: "saveBth",
              attrs: { round: "", type: "danger", size: "large" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.UpdateInfo($event)
                }
              }
            },
            [_vm._v("保存")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15e3ff86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e3ff86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Settings/UpdatePhone.vue
// module id = null
// module chunks = 